import { render, staticRenderFns } from "./LoyaltyPromoInviteMarketing.vue?vue&type=template&id=23e20ef2&scoped=true&lang=pug"
import script from "./LoyaltyPromoInviteMarketing.vue?vue&type=script&lang=ts"
export * from "./LoyaltyPromoInviteMarketing.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyPromoInviteMarketing.vue?vue&type=style&index=0&id=23e20ef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e20ef2",
  null
  
)

export default component.exports